// extracted by mini-css-extract-plugin
export default {"dialogTitle":"ContentDialog_dialogTitle__-ApOW","dialogContent":"ContentDialog_dialogContent__zdLFy","dialogActions":"ContentDialog_dialogActions__bsuxE"};